import clone from 'lodash/clone';
import { initialData } from 'scenes/Form/components/FirmStrategyCreateUpdateFundForm/initialData';

export const Normalizer = {
  fetch: data => {
    let FundNumberType = null;
    let FirmFundFocusID = null;
    let Vintage = null;

    if (data.fields && data.options) {
      FundNumberType =
        data.fields.FundNumberType && data.options.FundNumberType
          ? data.options.FundNumberType.find(
              t => t.value === data.fields.FundNumberType
            )
          : null;

      FirmFundFocusID =
        data.fields.FirmFundFocusID && data.options.FirmFundFocusID
          ? data.options.FirmFundFocusID.find(
              t => Number(t.value) === Number(data.fields.FirmFundFocusID)
            )
          : null;

      Vintage =
        data.fields.Vintage && data.options.Vintage
          ? data.options.Vintage.find(
              t => Number(t.value) === Number(data.fields.Vintage)
            )
          : null;
    }

    return {
      ...initialData,
      fields: {
        ...initialData.fields,
        ...data.fields,
        FundNumber: data.fields.FundNumber
          ? Number(data.fields.FundNumber)
          : '',
        FundNumberType,
        FirmFundFocusID,
        Vintage,
      },
      options: {
        ...initialData.options,
        ...data.options,
      },
      init: true,
    };
  },

  send: values => {
    const result = clone(values);
    Object.keys(result).forEach(f => {
      if ((!result[f] && !['Returns'].includes(f)) || result[f] === null) {
        delete result[f];
      } else if (['FundNumberType', 'FirmFundFocusID', 'Vintage'].includes(f)) {
        result[f] = result[f].value;
      }
    });

    return result;
  },
};
